<template>
  <StatusCheck
  idName="Tracking Number"
  :getStatusFields="fieldList"
  >
    <template #footer>
      <div class="fst-italic mt-3 text-muted">
        If you need further information concerning your request's status, please email the
        HRSA FOIA Office at <a :href="`mailto:${config.supportEmail}`"
        >{{ config.supportEmail }}</a>.
      </div>
    </template>
    <template #not-found-error>
      <div>
        Make sure you entered the Tracking Number and PIN correctly. If you need assistance,
        please email the HRSA FOIA Office at
        <a :href="`mailto:${config.supportEmail}`"
        >{{ config.supportEmail }}</a>.
      </div>
    </template>
  </StatusCheck>
</template>

<script>
import StatusCheck from '@/views/StatusCheck';
import { formatJsonDate } from '@/helpers/dateHelpers';

export default {
  inject: ['config'],

  components: {
    StatusCheck
  },

  methods: {
    fieldList: data =>
      [
        ['Tracking Number', data.controlNumber],
        ['Date Received', formatJsonDate(data.dateReceived)],
        ['Subject', data.subject],
        ['Status of the Request', data.status],
        ['FOIA Coordinator', data.coordinator || 'Undetermined'],
        ['Projected Date of Response', formatJsonDate(data.projectedDateOfResponse)],
        ['Date of Response', data.dateOfResponse ? formatJsonDate(data.dateOfResponse) : 'Undetermined']
      ]
  }
};
</script>
